// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhatsAppSupport_whatsappWrapper__kU2S8 {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
}

.WhatsAppSupport_whatsappFab__hjLml, .WhatsAppSupport_whatsappPill__nfh77 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--bw-primary, #82B194);
  color: #fff;
  border: 0;
  box-shadow: 0 12px 24px rgba(19, 35, 29, 0.18);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  z-index: 3;
}

.WhatsAppSupport_whatsappFab__hjLml:hover, .WhatsAppSupport_whatsappPill__nfh77:hover {
  background: var(--bw-primary-hover, #6b9a7c);
}

.WhatsAppSupport_whatsappFab__hjLml:active, .WhatsAppSupport_whatsappPill__nfh77:active {
  background: var(--bw-primary-active, #5c876a);
}

.WhatsAppSupport_whatsappFab__hjLml svg, .WhatsAppSupport_whatsappPill__nfh77 svg {
  width: 28px;
  height: 28px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.1;
  stroke-linecap: round;
  stroke-linejoin: round;
  flex: 0 0 auto;
}

.WhatsAppSupport_whatsappFab__hjLml {
  width: 58px;
  height: 58px;
  border-radius: 999px;
}

.WhatsAppSupport_whatsappPill__nfh77 {
  min-height: 48px;
  padding: 0 18px 0 14px;
  border-radius: 999px;
  gap: 10px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.WhatsAppSupport_helpBubble__LIinP {
  position: absolute;
  right: 0;
  bottom: calc(100% + 16px);
  width: max-content;
  max-width: 360px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 20px;
  box-shadow: 0 18px 44px rgba(16, 25, 21, 0.1);
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  pointer-events: none;
}

.WhatsAppSupport_helpBubble__LIinP:after {
  content: "";
  position: absolute;
  right: 20px;
  bottom: -10px;
  width: 20px;
  height: 20px;
  background: #fff;
  border-right: 1px solid rgba(16, 25, 21, 0.08);
  border-bottom: 1px solid rgba(16, 25, 21, 0.08);
  transform: rotate(45deg);
}

.WhatsAppSupport_helpBubble__LIinP strong {
  display: block;
  margin: 0 0 8px;
  color: var(--bw-text, #13231D);
  font-size: 18px;
  letter-spacing: -0.02em;
}

.WhatsAppSupport_helpBubble__LIinP span {
  display: block;
  color: var(--bw-text, #13231D);
  font-size: 14px;
  line-height: 1.55;
}

.WhatsAppSupport_whatsappWrapper__kU2S8:hover .WhatsAppSupport_helpBubble__LIinP,
.WhatsAppSupport_whatsappWrapper__kU2S8:focus-within .WhatsAppSupport_helpBubble__LIinP {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

@media (max-width: 980px) {
  .WhatsAppSupport_helpBubble__LIinP {
    width: calc(100vw - 48px);
    max-width: none;
    right: -12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/WhatsAppSupport/WhatsAppSupport.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,SAAA;EACA,8CAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,6CAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8CAAA;EACA,+CAAA;EACA,wBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,UAAA;EACA,mBAAA;EACA,wBAAA;AACF;;AAEA;EACE;IACE,yBAAA;IACA,eAAA;IACA,YAAA;EACF;AACF","sourcesContent":[".whatsappWrapper {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 1000;\n}\n\n.whatsappFab, .whatsappPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bw-primary, #82B194);\n  color: #fff;\n  border: 0;\n  box-shadow: 0 12px 24px rgba(19, 35, 29, 0.18);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 3;\n}\n\n.whatsappFab:hover, .whatsappPill:hover {\n  background: var(--bw-primary-hover, #6b9a7c);\n}\n\n.whatsappFab:active, .whatsappPill:active {\n  background: var(--bw-primary-active, #5c876a);\n}\n\n.whatsappFab svg, .whatsappPill svg {\n  width: 28px;\n  height: 28px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2.1;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  flex: 0 0 auto;\n}\n\n.whatsappFab {\n  width: 58px;\n  height: 58px;\n  border-radius: 999px;\n}\n\n.whatsappPill {\n  min-height: 48px;\n  padding: 0 18px 0 14px;\n  border-radius: 999px;\n  gap: 10px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.helpBubble {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 16px);\n  width: max-content;\n  max-width: 360px;\n  padding: 18px 20px;\n  background: #fff;\n  border: 1px solid rgba(16, 25, 21, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 18px 44px rgba(16, 25, 21, 0.10);\n  z-index: 2;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.helpBubble:after {\n  content: \"\";\n  position: absolute;\n  right: 20px;\n  bottom: -10px;\n  width: 20px;\n  height: 20px;\n  background: #fff;\n  border-right: 1px solid rgba(16, 25, 21, 0.08);\n  border-bottom: 1px solid rgba(16, 25, 21, 0.08);\n  transform: rotate(45deg);\n}\n\n.helpBubble strong {\n  display: block;\n  margin: 0 0 8px;\n  color: var(--bw-text, #13231D);\n  font-size: 18px;\n  letter-spacing: -0.02em;\n}\n\n.helpBubble span {\n  display: block;\n  color: var(--bw-text, #13231D);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.whatsappWrapper:hover .helpBubble,\n.whatsappWrapper:focus-within .helpBubble {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n@media (max-width: 980px) {\n  .helpBubble {\n    width: calc(100vw - 48px);\n    max-width: none;\n    right: -12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whatsappWrapper": `WhatsAppSupport_whatsappWrapper__kU2S8`,
	"whatsappFab": `WhatsAppSupport_whatsappFab__hjLml`,
	"whatsappPill": `WhatsAppSupport_whatsappPill__nfh77`,
	"helpBubble": `WhatsAppSupport_helpBubble__LIinP`
};
export default ___CSS_LOADER_EXPORT___;
